import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
} from "react";

const STORAGE_KEY = "mb-theme";

const readInitialTheme = () => {
    if (typeof window === "undefined") return "light";
    try {
        const v = window.localStorage.getItem(STORAGE_KEY);
        if (v === "dark" || v === "light") return v;
    } catch (_) {
        /* storage unavailable */
    }
    return "dark";
};

const ThemeContext = createContext({ theme: "light", toggle: () => {} });

export const ThemeProvider = ({ children }) => {
    // Lazy initializer reads storage synchronously so subsequent effects don't overwrite it.
    const [theme, setTheme] = useState(readInitialTheme);

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        try {
            window.localStorage.setItem(STORAGE_KEY, theme);
        } catch (_) {
            /* storage unavailable */
        }
    }, [theme]);

    const toggle = useCallback(
        () => setTheme((t) => (t === "light" ? "dark" : "light")),
        [],
    );

    return (
        <ThemeContext.Provider value={{ theme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
